import { Info } from 'lucide-react';
import type { OverlayTriggerState } from '@heroui/react';
import type { AvailabilityWindow } from '../../../api/my-parking-spots';
import { ConfirmDialog } from '../../../components/ui/confirm-dialog';
import { useRecurringAvailabilityEnabled } from '../../../hooks/useFeatureFlags';
import { formatDateTimeBR } from '../../../utils/date-utils';

interface ConfirmCancelWindowModalProps {
  state: OverlayTriggerState;
  window: AvailabilityWindow | null;
  onConfirm: () => Promise<void>;
  onConfirmSeries?: () => Promise<void>;
}

export function ConfirmCancelWindowModal({
  state,
  window,
  onConfirm,
  onConfirmSeries,
}: ConfirmCancelWindowModalProps) {
  // Com a flag off tratamos a ocorrência como janela comum: sem opção de série.
  const isSeries = useRecurringAvailabilityEnabled() && Boolean(window?.seriesId);
  return (
    <ConfirmDialog
      state={state}
      title="Cancelar disponibilização"
      cancelLabel="Não, manter janela"
      confirmLabel={isSeries ? 'Sim, só esta' : 'Sim, cancelar'}
      confirmVariant="danger-soft"
      confirmDisabled={!window}
      extraAction={
        isSeries && onConfirmSeries
          ? {
              label: 'Cancelar a série',
              variant: 'danger',
              onPress: onConfirmSeries,
            }
          : undefined
      }
      onConfirm={onConfirm}
      message={
        <>
          <p className="text-muted">
            {isSeries
              ? 'Esta janela faz parte de uma série recorrente. Você pode cancelar só esta ocorrência ou todas as futuras.'
              : 'Tem certeza que deseja cancelar esta janela de disponibilidade?'}
          </p>
          {window ? (
            <p className="mt-2 text-sm text-muted">
              Período: <strong>{formatDateTimeBR(window.startAt)}</strong> até{' '}
              <strong>{formatDateTimeBR(window.endAt)}</strong>
            </p>
          ) : null}
          <p className="mt-2 flex items-start gap-1 text-sm text-muted">
            <Info size={14} className="mt-0.5 shrink-0" />A vaga deixará de ficar disponível para
            empréstimo ou aluguel neste período.
          </p>
        </>
      }
    />
  );
}
